import React, { useEffect, useState } from "react";
import { Table } from "antd";
import moment from "moment";
import Breadcrumbs from "../../../components/Breadcrumbs";
import {
  calculateOvertime,
  calculateTimeDifference,
  convertTimeFormat,
  formatDate2,
  formatDateToFullDateString,
} from "../../../validation";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import AttendanceApprovalForm from "./AttendanceApprovalForm";
import api from "../../../api/axios";
import { useLocation, useParams } from "react-router-dom";
import ExportAttendanceModal from "../../../components/modelpopup/ExportAttendanceModal";
import { exportAttendanceData } from "../../../services/attendanceService";
import { decrypt } from "../../../utils/crypto";

const AttendanceEmployee = () => {
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const location = useLocation();
  const { employeeName = "" } = location.state || {};
  const [data, setData] = useState([]);
  const [activity, setActivity] = useState([]);
  const [totalHoursToday, setTotalHoursToday] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [attendanceApprovalData, setAttendanceApprovalData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [employeeAttendanceDetail, setEmployeeAttendanceDetail] = useState({});
  const [activityDetail, setActivityDetail] = useState([]);

  function getCurrentDate() {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 10);
  }
  console.log("activity" , activity)

  let loginEmployeeId = localStorage.getItem("employeeID");
  useEffect(() => {
    api
      .get(`api/attendance/${employee_id}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.error("Error fetching attendance data:", err));
  }, []);

  useEffect(() => {
    api
      .get(`api/attendance/today/${employee_id}`)
      .then((res) => {
        console.log("Today's activity data fetched:", res.data);
        setActivity(res?.data?.results);

        let totalHours = 0;
        const punchIns = res?.data?.results.filter(
          (act) => act.title === "Login"
        );
        const punchOuts = res?.data?.results.filter(
          (act) => act.title === "Logout"
        );
        console.log("punch ins->", punchIns);

        if (punchIns?.length > 0 && punchOuts?.length > 0) {
          const firstPunchIn = moment(punchIns[0].time);
          const lastPunchOut = moment(punchOuts[punchOuts.length - 1].time);
          totalHours = lastPunchOut.diff(firstPunchIn, "hours", true);
          console.log("total hours-->", totalHours);
          setTotalHoursToday(totalHours);
        } else {
          const firstPunchIn = moment(punchIns[0].time);
          const lastPunchOut = moment(new Date().time);
          totalHours = lastPunchOut.diff(firstPunchIn, "hours", true);
          setTotalHoursToday(totalHours);
          console.log("total hours-->", totalHours);
        }
      })
      .catch((err) => console.error("Error fetching today's activity:", err));
  }, []);

  const formatTotalHours = (totalHours) => {
    const hours = Math.floor(totalHours);
    const minutes = Math.floor((totalHours % 1) * 60);
    const seconds = Math.round(((totalHours * 60) % 1) * 60);

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds} hrs`;
  };

  const fetchTotalHours = (punchIns, punchOuts) => {
    let totalHours = 0;

    if (punchIns?.length > 0 && punchOuts?.length > 0) {
      // Ensure punchOuts has enough data to match with punchIns
      const validPunchOuts = punchOuts.slice(0, punchIns.length);

      // Calculate total hours based on punch-ins and corresponding punch-outs
      let totalMinutes = 0;
      for (let i = 0; i < validPunchOuts.length; i++) {
        const punchInTime = moment(punchIns[i].time);
        const punchOutTime = moment(validPunchOuts[i].time);
        totalMinutes += punchOutTime.diff(punchInTime, "minutes");
      }

      totalHours = totalMinutes / 60;
    } else {
      const firstPunchIn =
        punchIns?.length > 0 ? moment(punchIns[0]?.time) : null;
      const punchInDate = firstPunchIn
        ? firstPunchIn.format("YYYY-MM-DD")
        : null;
      const currentDate = moment().format("YYYY-MM-DD");

      if (!punchOuts || punchOuts?.length === 0) {
        if (punchInDate !== currentDate) {
          // If punch-in date is not today
          totalHours = 0; // Set total hours to 0
        } else {
          // If punch-in date is today
          if (firstPunchIn) {
            const lastPunchOut = moment(); // Current time
            totalHours = lastPunchOut.diff(firstPunchIn, "hours", true);
          }
        }
      }
    }

    // Format total hours as HH:mm:ss
    const hours = Math.floor(totalHours);
    const minutes = Math.floor((totalHours - hours) * 60);
    const seconds = Math.floor(((totalHours - hours) * 60 - minutes) * 60);

    const formatTime = (num) => num.toString().padStart(2, "0");
    const formattedTotalHours = `${formatTime(hours)}:${formatTime(
      minutes
    )}:${formatTime(seconds)}`;

    console.log("Total hours -->", formattedTotalHours);
    return formattedTotalHours;
  };

  const userElements = data.map((user, index) => ({
    key: index,
    id: index + 1,
    Date: user.Date,
    PunchIn: user?.punchIn ? moment(user.punchIn).format("hh:mm A") : "-",
    PunchOut: user?.punchOut ? moment(user.punchOut).format("hh:mm A") : "-",
    TotalHours:
      user.totalHours !== undefined && !isNaN(user.totalHours)
        ? formatTotalHours(user.totalHours) !== `00:00:00 hrs`
          ? formatTotalHours(Number(user.totalHours) + Number(user?.overtime))
          : fetchTotalHours(user.punchIn, user.punchOut)
        : "-",
    attendance_id: user.id,
    marked_full_day_attendance: user.marked_full_day_attendance,
    employeeId: user.employee_id,
    total_hours: user.totalHours,
    attendance_approval_status: user.attendance_approval_status,
    employee_presence: user?.employee_presence,
    approval_remark: user?.approval_remark,
    approval_message: user?.approval_message,
    approval_reason_id : user?.approval_reason_id,
    reason_name : user?.reason_name,
    approval_id : user?.approval_id,
  }));

  const [isApplyRegularization, setIsApplyRegularization] = useState(false);
  const handleCanApplyRegularization = async () => {
    try {
      const response = await api.get(`employee_allowance?employee_id=${employee_id ?? localStorage.getItem("employeeID")}`);
      console.log("response", response)
      if (response?.data?.result[0]?.approval_not_allow == 1) {
        console.log("response?.data?.result[0]?.approval_not_allow", response?.data?.result[0]?.approval_not_allow)
        setIsApplyRegularization(true);
      }
      else {
        setIsApplyRegularization(false);

      }
    }
    catch (error) {
      console.error("Error checking leave permission:", error);
    }
  }

  useEffect(()=>{
    handleCanApplyRegularization(); 
  },[])

  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      sorter: (a, b) => new Date(a.Date) - new Date(b.Date),
    },
    {
      title: "Punch In/Out",
      dataIndex: "PunchIn",
      render: (_, record) => (
        <div className="d-flex align-items-center ml-2 bg-light rounded">
          <span style={{ fontSize: "14px" }} className="text-muted">
            {record.PunchIn || "N/A"} - {record.PunchOut || "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "Total Hours",
      dataIndex: "TotalHours",
      render: (TotalHours, record) => {
        const color =
          record?.employee_presence === "full_day"
            ? "black"
            : record?.employee_presence === "half_day"
            ? "warning"
            : "danger";

        return (
          <span className={`${TotalHours && `text-${color}`}`}>
            {TotalHours}
          </span>
        );
      },
      // sorter: (a, b) => parseFloat(a.TotalHours) - parseFloat(b.TotalHours),
    },
    {
      title: "Presence",
      dataIndex: "employee_presence",
      render: (text) => {
        const color =
          text === "full_day"
            ? "success"
            : text === "half_day"
            ? "warning"
            : "danger";
        return (
          <span className={`${text && `badge badge-${color}`}`}>
            {text
              ? text
                  ?.replace(/_/g, " ")
                  .toLowerCase()
                  .replace(/^./, (s) => s.toUpperCase())
              : "-"}
          </span>
        );
      },
    },
    ...(loginEmployeeId === employee_id
      ? [
          {
            title: "Approval Status",
            dataIndex: "attendance_approval_status",
            render: (text, record) => {
              return (
                <span
                  style={{
                    color:
                      text == "pending"
                        ? "rgb(255, 223, 0)"
                        : text == "rejected"
                        ? "red"
                        : "green",
                  }}
                >
                  {text ? text.charAt(0).toUpperCase() + text.slice(1) : "-"}
                </span>
              );
            },
          },
        ]
      : []),
    {
      title: "Remark",
      dataIndex: "remark",
      render: (_, record) => (
        <div className="d-flex align-items-center ml-2 rounded">
          <span
            style={{
              fontSize: "14px",
              display: "inline-block",
              maxWidth: "100px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
            className="text-muted"
            title={record.approval_remark || "-"}
          >
            {record.approval_remark?.length > 20
              ? `${record.approval_remark.slice(0, 20)}...`
              : record.approval_remark || "-"}
          </span>
        </div>
      ),
    },
    ...(loginEmployeeId === employee_id
      ? [
          {
            title: "Action",
            dataIndex: "",
            onCell: () => ({
              onClick: (e) => e.stopPropagation(),
            }),
            render: (_, record) => {
              const currentDate = getCurrentDate();
              const isSameDate = currentDate === record.Date;
              const isPending = record.attendance_approval_status === "pending";
              const isAlreadyApproved =
                record.attendance_approval_status != null;

              const isDisabled = isSameDate || isAlreadyApproved;

              const tooltipText = !isApplyRegularization ? isPending
                ? "Edit"
                : !isDisabled
                ? "Apply for Approval"
                : "Not allowed" :" Regularization not allowed"; ;

              const handleClick = () => {
                if (!isSameDate && (isPending || !isAlreadyApproved)) {
                  setIsModalOpen(true);
                  setAttendanceApprovalData(record);
                }
              };

              const isClickable = isApplyRegularization ? false : 
                (!isSameDate && (isPending || !isAlreadyApproved) ) ;

              const iconStyle = {
                color: isClickable ? "#1E90FF" : "#B0B0B0",
                cursor: isClickable ? "pointer" : "not-allowed",
                marginRight: "8px",
              };

              return (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip
                      id="tooltip-view"
                      style={{ fontSize: "12px", padding: "2px" }}
                    >
                      {tooltipText}
                    </Tooltip>
                  }
                >
                  <i
                    className={`fa ${isPending ? "fa-edit" : "fa-paper-plane"}`}
                    style={iconStyle}
                    onClick={handleClick}
                  ></i>
                </OverlayTrigger>
              );
            },
          },
        ]
      : []),
  ];

  // Display total hours in circles
  const totalHoursCircles = totalHoursToday.toFixed(2); // Ensure it matches the table display

  // ---------- todays data ------------------------

  const filterTodayData = (data) => {
    const today = new Date().toISOString().split("T")[0];
    console.log("today date", today); // Get today's date in YYYY-MM-DD format
    return data.filter((item) => item.Date.startsWith(today));
  };
  const todaysData = filterTodayData(data);
  console.log("todays data ", todaysData);

  const exportAttendance = async (params) => {
    try {
      await exportAttendanceData(params);
    } catch (error) {
      console.error(error);
    }
  };

  const employeeAttendanceHandler = async (date) => {
    try {
      if (!employee_id || !date) {
        return;
      }
      const response = await api.get(
        `api/attendance/attendace/${employee_id}/${date}`
      );
      if (response?.data?.result) {
        setEmployeeAttendanceDetail(response?.data?.result[0]);
      }
      if (response?.data?.results) {
        setActivity(response?.data?.results);
      }
    } catch (err) {
      console.log(err);
    }
  };


  function convertToTimeFormat(totalHours, overtime) {
    if (totalHours == null || totalHours === "") {
      return 0;
    }
    const hoursNum = Number(totalHours);
    if (isNaN(hoursNum)) {
      return 0;
    }
    let total = hoursNum;
    if (overtime != null && overtime !== "") {
      const overtimeNum = Number(overtime);
      if (!isNaN(overtimeNum)) {
        total += overtimeNum;
      } else {
        return 0;
      }
    }
    if (total < 0) {
      return 0;
    }
    const hours = Math.floor(total);
    const minutes = Math.floor((total - hours) * 60);
    const seconds = Math.round(((total - hours) * 60 - minutes) * 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid position-relative">
          <Breadcrumbs
            maintitle={`${employeeName} Attendance`}
            title="Dashboard"
            subtitle="Attendance"
          />
          <div className="row">
            <div className="col-md-4">
              <div className="card punch-status">
                <div className="card-body">
                  <h5 className="card-title">
                    Timesheet{" "}
                    <small className="text-muted">
                      {employeeAttendanceDetail?.date
                        ? formatDate2(employeeAttendanceDetail?.date)
                        : moment().format("DD MMM YYYY")}
                    </small>
                  </h5>
                  <div className="punch-det">
                    <h6>Punch In at</h6>
                    <p>
                      {employeeAttendanceDetail?.date
                        ? formatDateToFullDateString(
                            employeeAttendanceDetail?.date
                          )
                        : todaysData[0]?.date &&
                          formatDateToFullDateString(todaysData[0]?.date)}{" "}
                      {/* {todaysData[0]?.PunchIn &&
                        convertTimeFormat(todaysData[0]?.punchIn)} */}
                      {employeeAttendanceDetail?.punchIn
                        ? moment(employeeAttendanceDetail?.punchIn).format(
                            "hh:mm:ss A"
                          )
                        : todaysData[0]?.date &&
                          moment(todaysData[0]?.punchIn).format("hh:mm A")}
                    </p>
                  </div>
                  <div className="punch-info">
                    <div
                      className="punch-hours "
                      style={{ textAlign: "center" }}
                    >
                      <span>
                        {employeeAttendanceDetail?.overtime ||
                        employeeAttendanceDetail?.totalHours
                          ? convertToTimeFormat(
                              employeeAttendanceDetail?.totalHours,
                              employeeAttendanceDetail?.overtime
                            )
                          : employeeAttendanceDetail?.punchIn
                          ? calculateTimeDifference(
                              employeeAttendanceDetail?.punchIn
                            )
                          : totalHoursToday &&
                            formatTotalHours(totalHoursToday)}
                      </span>
                    </div>
                  </div>
                  <div className="punch-det">
                    <h6>Punch Out at</h6>
                    <p>
                      {employeeAttendanceDetail?.date
                        ? formatDateToFullDateString(
                            employeeAttendanceDetail?.date
                          )
                        : todaysData[0]?.date &&
                          formatDateToFullDateString(todaysData[0]?.date)}{" "}
                      {employeeAttendanceDetail?.punchOut
                        ? moment(employeeAttendanceDetail?.punchOut).format(
                            "hh:mm A"
                          )
                        : todaysData[0]?.punchOut &&
                          moment(todaysData[0]?.punchOut).format("hh:mm A")}
                    </p>
                  </div>
                  {/* <div className="statistics">
                    <div className="row">
                      <div className="col-md-6 col-6 text-center">
                        <div className="stats-box">
                          <p>Break</p>
                          <h6>1.00 hrs</h6>
                        </div>
                      </div>
                      <div className="col-md-6 col-6 text-center">
                        <div className="stats-box">
                          <p>Overtime</p>
                          <h6>
                            {calculateOvertime(
                              formatTotalHours(totalHoursToday),
                              estimatedWorkingHours
                            )}
                          </h6>{" "}
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="card recent-activity">
                <div className="card-body">
                  <h5 className="card-title">Today's Activity</h5>
                  <ul className="res-activity-list">
                    {activity.length > 0 ? (
                      activity.map((act, index) => (
                        <li key={index}>
                          <p className="mb-0">
                            {act?.activity_type == "Login" || act?.title == "Login"
                              ? "Punch In at"
                              : "Punch Out at"}
                          </p>
                          <p className="res-activity-time">
                            <i className="fa fa-clock-o"></i>{" "}
                            {moment(act?.activity_time || act?.time).format("hh:mm A")}
                          </p>
                        </li>
                      ))
                    ) : (
                      <li>No activities for today</li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-3 d-flex justify-content-end gap-2">
            <Button variant="link" onClick={() => setShowModal(true)}>
              Export Attendance
            </Button>
            {showModal && (
              <ExportAttendanceModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                exportSheet={exportAttendance}
                selectedEmployee={employee_id}
              />
            )}
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Attendance</h5>
                  <Table
                    className="table-striped"
                    onRow={(record) => {
                      return {
                        onClick: () => {
                          console.log("Row clicked:", record);
                          employeeAttendanceHandler(record?.Date);
                        },
                      };
                    }}
                    pagination={{
                      total: data.length,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      showSizeChanger: true,
                      itemRender: (current, type, originalElement) => {
                        if (type === "prev") {
                          return <a>Previous</a>;
                        }
                        if (type === "next") {
                          return <a>Next</a>;
                        }
                        return originalElement;
                      },
                    }}
                    style={{ overflowX: "auto" }}
                    columns={columns}
                    dataSource={userElements}
                    rowKey={(record) => record.id}
                    scroll={{ x: true }}
                    tableLayout="auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AttendanceApprovalForm
        attendanceApprovalData={attendanceApprovalData}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      {isModalOpen && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default AttendanceEmployee;
